import { useLocation } from "@workflows/runtime-web";
interface Step {
  step: number;
  url: string;
}
export interface Steps {
  current: Step;
  next: Step;
  back: Step;
}
export const useStepLookup = (urls: string[]): Steps => {
  const location = useLocation();
  const currentStep = getCurrentStep(urls, location.pathname);
  return {
    current: currentStep,
    next: getNextStep(urls, currentStep.step),
    back: getPreviousStep(urls, currentStep.step)
  };
};
const getCurrentStep = (urls: string[], path: string): Step => {
  const index = urls.indexOf(path);
  return {
    step: index,
    url: urls[index]
  };
};
const getPreviousStep = (urls: string[], currentStep: number): Step => {
  const previousStep = currentStep - 1;
  return {
    step: previousStep,
    url: urls[previousStep]
  };
};
const getNextStep = (urls: string[], currentStep: number): Step => {
  const nextStep = currentStep + 1;
  if (nextStep >= urls.length) {
    return {
      step: urls.length,
      url: urls[urls.length - 1]
    };
  }
  return {
    step: nextStep,
    url: urls[nextStep]
  };
};